import { CandidatePersonalDetailsFormModel } from 'store/candidate/types';

export const DEFAULT_FORM_VALUES: CandidatePersonalDetailsFormModel = {
  otherNames: '',
  familyName: '',
  hasFamilyName: true,
  email: '',
  dob: '',
  gender: '',
  address: {
    streetAddress1: '',
    streetAddress2: '',
    streetAddress3: '',
    streetAddress4: '',
    city: '',
    postCode: '',
    countryId: '',
  },
  mobile: '',
  telephone: '',
  uciEdexcel: '',
  uciAqa: '',
  guardianContactDetails: {
    firstName: '',
    lastName: '',
    email: '',
    familyRelationship: '',
    familyRelationshipId: '',
    dateOfBirth: '',
    mobile: '',
    telephone: ''
  },
};
